const validations = {
  firstName: {
    required: true,
    minLength: 2,
  },
  lastName: {
    required: true,
    minLength: 2,
  },
  email: {
    required: true,
    isEmail: true,
  },
};

export { validations };
